import React, { useState } from 'react';
import moment from 'moment';
import { Field, Tooltip } from '@ontruck/orc';
import cx from 'classnames';
import TinyDateField from 'components/TinyDateField';
import PropTypes from 'prop-types';

const t = {
  wrong_hour: "You can't set an hour before the previous stop time",
};

/**
 * @param {string} time
 * @returns {string[]}
 */
const getHourMinutesFromTime = (time = '') => {
  return time ? time.split(':') : [];
};

/**
 * @param {string} date
 * @returns {string[]}
 */
const getMonthDateFromDate = (date = '') => {
  return date ? date.split('/') : [];
};

/**
 * @param {string} timeValue hh:mm
 * @param {string} [dateValue] dd/mm
 * @returns {moment.Moment}
 */
export const generateDateTime = (timeValue, dateValue) => {
  const [hour, minutes] = getHourMinutesFromTime(timeValue);

  if (hour < 24 && minutes < 60) {
    const [date, month] = getMonthDateFromDate(dateValue);
    const dateTime = moment();
    dateTime.set({ hour, minutes });

    if (month <= 12 && date <= 31) {
      dateTime.set({ month: month - 1, date });
    }
    return dateTime;
  }
  return null;
};

const getPreviousTime = (previousStageTimeDone) => {
  if (!previousStageTimeDone) return null;
  return moment(previousStageTimeDone);
};

const SelectHour = ({ previousStageTimeDone, setShowInput, handleAdvance, className }) => {
  const [time, setTime] = useState(moment().format('HH:mm'));
  const [date, setDate] = useState(moment().format('DD/MM'));
  const [dateTimeError, setDateTimeError] = useState(false);

  const handleChangeTime = (e, { value }) => {
    setTime(value);
    setDateTimeError(false);
  };

  const handleChangeDate = (selectedDate) => {
    const newDate = moment(selectedDate).format('DD/MM');
    setDateTimeError(false);
    setDate(newDate);
  };

  const handleCancel = () => {
    setShowInput(false);
    setDateTimeError(false);
  };

  const handleTimeKeyPress = (event) => {
    const { key } = event;

    if (key === 'Escape') {
      handleCancel();
      return;
    }
    if (key !== 'Enter') {
      return;
    }
    handleOnChange(event);
  };

  const handleOnChange = (event) => {
    const newDateTime = generateDateTime(time, date);
    const prevDateTime = getPreviousTime(previousStageTimeDone);
    if (!!prevDateTime && !!newDateTime && newDateTime.isBefore(prevDateTime)) {
      setDateTimeError(true);
      setTimeout(() => setDateTimeError(false), 4000);
      return;
    }
    if (newDateTime) {
      handleAdvance(event, newDateTime);
    }
  };

  const inputComponent = (
    <div
      className={cx(className, { 'background-error': dateTimeError })}
      onClick={(e) => e.stopPropagation()}
    >
      <Field
        className="field time-input"
        maskedProps={{ mask: '99:99', maskChar: null }}
        onChange={handleChangeTime}
        onKeyUp={handleTimeKeyPress}
        value={time}
        id="field-m-size"
        width="S"
        label=""
        name=""
      />
      <TinyDateField
        className="field date-input"
        onCancel={handleCancel}
        onChange={handleChangeDate}
        onSubmit={handleOnChange}
      />
    </div>
  );

  return (
    <>
      {!dateTimeError && inputComponent}
      {dateTimeError && (
        <Tooltip
          component={t.wrong_hour}
          skin="light"
          position="top"
          align="center"
          size="M"
          bodySize="M"
          alwaysVisible
        >
          {inputComponent}
        </Tooltip>
      )}
    </>
  );
};

TinyDateField.propTypes = {
  previousStageTimeDone: PropTypes.string,
  setShowInput: PropTypes.func,
  handleAdvance: PropTypes.func,
};

export default SelectHour;
